import { ShortcutType } from "@/lib/types"
import useBrowserStore from "@/store/browserStore";
import { useMethodActions } from "@/store/MethodStore";
import { LucideGalleryVerticalEnd } from "lucide-react";
import { IoMdDownload } from "react-icons/io";
import { IoArrowBackOutline, IoDocumentSharp, IoPersonSharp } from "react-icons/io5";
import { MdOpenInNew } from "react-icons/md";

function useShortcuts() {

  const setLink= useBrowserStore(state=>state.setLink)
  const { setBrowserState, setFocusedWindow } = useMethodActions()

  const openHandler = (link: string) => {
    setBrowserState("floating");
    setFocusedWindow("Browser");
    setLink(link)
  }

  function downloadFile(url: string, filename: string) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const shortcuts: ShortcutType[] = [
    { 
      name: "Project Gallery", 
      minimalIcon: <LucideGalleryVerticalEnd />, 
      onClickHandler: () => openHandler(`https://dhvanitmonpara.in/projects`), 
      icon: <img className="w-12" src="./apps/icons8-gallery-48.png" />, 
      contextMenu: [{ icon: <MdOpenInNew className="text-lg" />, name: "Open", onClickHandler: () => openHandler(`${import.meta.env.VITE_CLIENT_BASE_URL}/projects`) }] },
    {
      name: "Portfolio",
      minimalIcon: <IoPersonSharp />,
      onClickHandler: () => window.open("https://dhvanitmonpara.in/", "_blank"), icon: <img className="w-12" src="./apps/icons8-person-50.png" />, 
      contextMenu: [
        {
          icon: <IoArrowBackOutline className="text-lg" />, name: "Go to portfolio", onClickHandler: () => window.open("https://dhvanitmonpara.in/", "_blank")
        },
        {
          onClickHandler: () => window.open("https://dhvanitmonpara.in/", "_blank"),
          name: "Open in new tab",
          icon: <MdOpenInNew className="text-lg" />
        }
      ]
    },
    {
      name: "Resume",
      minimalIcon: <IoDocumentSharp />,
      onClickHandler: () => window.open("https://dhvanitmonpara.in/resume", "_blank"), icon: <img className="w-12" src="./apps/icons8-resume-50.png" />, contextMenu: [
        {
          icon: <MdOpenInNew className="text-lg" />,
          name: "Open",
          onClickHandler: () => window.open("https://dhvanitmonpara.in/resume.pdf", "_blank")
        },
        {
          onClickHandler: () => downloadFile("https://dhvanitmonpara.in/resume.pdf", "resume.pdf"),
          name: "Save",
          icon: <IoMdDownload className="text-lg" />
        }
      ]
    },
  ]

  return shortcuts
}

export default useShortcuts